import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select as MantineSelect, } from '@mantine/core';
import { cn } from '@monorepo/utils';
import { Icon } from '@iconify-icon/react';
const Select = React.forwardRef(({ value, size = 'md', ...props }, ref) => {
    const classNames = props.classNames;
    return (_jsx(MantineSelect, { ref: ref, size: size, value: value, autoComplete: "nope", rightSection: _jsx(Icon, { icon: "tabler:chevron-down", className: "text-xl text-gray-800" }), ...props, classNames: {
            ...classNames,
            input: cn('h-11 rounded-lg text-sm border whitespace-nowrap truncate border-gray-300 placeholder:font-medium placeholder:text-gray-800', classNames?.input),
            option: cn('hover:bg-primary-100 text-sm data-[checked]:bg-primary-600 data-[checked]:text-white', classNames?.option),
            dropdown: cn('rounded-lg', classNames?.dropdown),
            root: cn('cursor-pointer', classNames?.root),
            label: cn('text-sm text-gray-800 font-medium mb-1', classNames?.label),
            error: cn('text-sm text-red-500', classNames?.error),
        } }));
});
Select.displayName = 'Select';
export default Select;
